var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.35,
    height: 8.405,
    viewBox: "0 0 10.35 8.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M9.286,5.476c.007.092.007.184.007.276a5.994,5.994,0,0,1-6.035,6.035A5.994,5.994,0,0,1,0,10.834a4.388,4.388,0,0,0,.512.026,4.248,4.248,0,0,0,2.633-.906A2.125,2.125,0,0,1,1.162,8.483a2.675,2.675,0,0,0,.4.033,2.243,2.243,0,0,0,.558-.072A2.121,2.121,0,0,1,.42,6.362V6.336a2.136,2.136,0,0,0,.959.269A2.124,2.124,0,0,1,.722,3.768,6.029,6.029,0,0,0,5.1,5.988,2.394,2.394,0,0,1,5.043,5.5,2.123,2.123,0,0,1,8.714,4.051a4.176,4.176,0,0,0,1.346-.512,2.115,2.115,0,0,1-.933,1.169,4.252,4.252,0,0,0,1.221-.328A4.56,4.56,0,0,1,9.286,5.476Z",
    transform: "translate(0 -3.381)",
    fill: "rgba(3,37,41,0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.f1c720cd2569a57399cd39d4abe1c424.svg";
export { ForwardRef as ReactComponent };